import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f60c48e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 text-center" }
const _hoisted_2 = { class: "row g-6 g-xl-9" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PathwayListCard = _resolveComponent("PathwayListCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.pathways.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.pathways, (pathway) => {
            return (_openBlock(), _createBlock(_component_PathwayListCard, {
              key: pathway.id,
              pathway: pathway,
              onClick: _ctx.navigateToPathway
            }, null, 8, ["pathway", "onClick"]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
    ])
  ]))
}